export default __webpack_public_path__ + "images/6bb21294da4a008a87fcec5ed94be18d.png";